// Clerk SignIn / SignUp appearance — matches our dark + glowing green palette.
// Clerk uses inline CSS vars (cl-*) for its Elements layout; class overrides
// are layered on top for fine-grained control. Keep this in sync with
// tokens.css if the palette shifts.

import type { Appearance } from '@clerk/types';

export const clerkDarkAppearance: Appearance = {
  variables: {
    colorPrimary: '#22d47a', // greeniq-500
    colorBackground: '#131920', // bg-card
    colorInput: '#0b1014', // bg-page, inset feel inside the card
    colorInputForeground: '#f0f2f5',
    colorForeground: '#f0f2f5',
    colorMutedForeground: '#a0a8b4',
    colorNeutral: '#f0f2f5',
    colorDanger: '#ff6b6b',
    colorSuccess: '#22d47a',
    colorWarning: '#f5a623',
    borderRadius: '13px',
    fontFamily: "'DM Sans', system-ui, sans-serif",
    fontFamilyButtons: "'Outfit', system-ui, sans-serif",
  },
  elements: {
    rootBox: 'w-full',
    card: 'bg-bg-card border border-border shadow-lg',
    headerTitle: 'font-display text-fg',
    headerSubtitle: 'text-fg-secondary',
    socialButtonsBlockButton:
      'bg-bg-elevated border border-border text-fg hover:bg-bg-hover',
    formFieldLabel: 'text-fg-secondary uppercase tracking-wider text-[11px]',
    formFieldInput:
      'bg-bg-input border border-border text-fg focus:border-greeniq-500 focus:shadow-focus',
    formButtonPrimary:
      'bg-greeniq-500 text-[#0b1014] hover:bg-greeniq-400 font-display font-semibold shadow-glow-green hover:shadow-glow-green-strong',
    footerActionLink: 'text-greeniq-400 hover:text-greeniq-300',
    identityPreviewText: 'text-fg',
    identityPreviewEditButtonIcon: 'text-greeniq-400',
    dividerLine: 'bg-border',
    dividerText: 'text-fg-muted',
    formFieldSuccessText: 'text-[color:var(--color-success)]',
    formFieldErrorText: 'text-[color:var(--color-error)]',
    alert: 'bg-error-muted border border-[color:var(--color-error)]/30',
  },
};
